import request from './index'

export const allMenuItem = (roleId) => {
  return request({
    url: '/menu/allMenuItem',
    method: 'post',
    data: {
      roleId: roleId
    }
  })
}

export const addMenuItem = (roleId, menuItem) => {
  return request({
    url: '/menu/addMenuItem',
    method: 'post',
    data: {
      roleId: roleId,
      command_id: 0,
      menuItem: menuItem
    }
  })
}

export const updateMenuItem = (roleId, menuItem) => {
  return request({
    url: '/menu/updateMenuItem',
    method: 'post',
    data: {
      roleId: roleId,
      command_id: 0,
      menuItem: menuItem
    }
  })
}

export const deleteMenuItem = (roleId, menuItem) => {
  return request({
    url: '/menu/deleteMenuItem',
    method: 'post',
    data: {
      roleId: roleId,
      command_id: 0,
      menuItem: menuItem
    }
  })
}